<template>
    <Button :icon="attrs.icon" @click="handleClick" :loading="isLoading"  v-if="isDisplay" :type="attrs.btnStyle">
        {{attrs.title}}
    </Button>
</template>
<script>
    /**
     * 功能型操作按钮，使用场景:改变某状态，然后刷新页面
     * 此按钮本质上是 delete-button的升级版，可以代替之
     * 
     * 获取用户信息vuex
     * 2021-9-21 modify by wxf
     * 
     * 增加btnStyle
     * 2022-03-29 modify by wxf
     */
    import CompEventMixin from '@/utils/compEvent.mixin'
    import CompDisplayMixin from '@/utils/compDisplay.mixin'
    import {mapGetters} from 'Vuex'
    export default {
        name: 'LyPowerButton',
        mixins: [CompEventMixin, CompDisplayMixin],
        props: {
            row: {
                type: Object,
                default: _ => new Object()
            } // 提供给tabel，用于绑定行数据
        },
        data () {
            return {
                isLoading: false // 标识，是否是在提交
            }
        },
        computed: {
            ...mapGetters(['userInfo'])
        },
        methods: {
            /**
             * 按钮点击的监听
             */
            handleClick () {
                let content = '<p>'
                if (this.attrs.tips && this.attrs.tips.length > 0) {
                    content += this.attrs.tips
                } else {
                    content += '你确定要进行 ' + this.attrs.title + ' 操作？'
                }
                content += '</p>'
                this.$Modal.confirm({
                    title: '操作确认',
                    content: content,
                    onOk: () => {
                        this.doPower()
                    }
                })
            },
            /**
             * 进行操作
             */
            doPower () {
                this.isLoading = true
                let params = {} // 上传参数
                let url = this.attrs.api 
                let paramsMatchObj = this.page // 用于匹配url参数的对象
                // 判断是否是列表多选项数据
                if (this.tableSelectLists && this.tableSelectLists.length > 0) {
                    params['tableSelectLists'] = this.tableSelectLists
                }else if (this.row.hasOwnProperty('id') ||  this.attrs.mark == 'table') { // row有字段说明是表格中传递过来的
                    paramsMatchObj = this.row
                }
                let path = this.$path.getPath(url, paramsMatchObj, this.attrs.method)
                if (typeof path == 'string') {
                    url = path
                } else if (typeof path == 'object'){ // POST上传参数
                    url = path.url
                    Object.assign(params, path.params)
                }
                // 2010-03-21 批量审核加入的专有属性
                if (this.attrs.isBatchAudit) {
                    // 将提交的数据和url发送出去
                    this.$eventHub.$emit(this.$events.BATCH_AUDIT_SUBMIT_DATA, {
                        url: url,
                        method: this.attrs.method,
                        data: params
                    })
                    this.isLoading = false
                } else {
                    this.$api[this.attrs.method](url, params).then(() => {
                        this.isLoading = false
                        this.$Message.success('操作成功')
                        // 如果过是表格中传递过来的数据，通知刷新当前页面
                        if (this.row.hasOwnProperty('id')) {
                            // 发送刷新页面数据的事件
                            this.$eventHub.$emit(this.$events.REFRESH_SEARCH_DATA)
                        } else { // 跳转路由                
                            if (this.attrs.route.length > 0) {     
                                 // 刷新当前页面
                                if (this.attrs.route == ':rf') {
                                    location.reload()
                                } else {
                                    // 表格删除没有跳转
                                    let backRoute = this.$path.getPath(this.attrs.route, this.page) 
                                    this.$router.push({path: backRoute})
                                }
                            } else {
                                // 发送刷新页面数据的事件
                                this.$eventHub.$emit(this.$events.REFRESH_SEARCH_DATA)
                            }
                        }
                    }).catch((err) => {
                        this.isLoading = false
                        console.error(err)
                        this.$Message.error({content: err, duration: 5 })
                    })
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ../projectCore/src/components/power-button/src/index.vue